export default {
	service: process.env.REACT_APP_OBSERVABILITY_SERVICE,
	datadogSite: process.env.REACT_APP_OBSERVABILITY_DATADOG_SITE,
	datadogApplicationId: process.env.REACT_APP_OBSERVABILITY_DATADOG_APPLICATION_ID,
	datadogClientToken: process.env.REACT_APP_OBSERVABILITY_DATADOG_CLIENT_TOKEN
}
